import { ListItem } from 'interfaces/ui/ui-list-item';
import { Location } from 'model';
import { OptionTypeBase } from 'react-select';

export function convertValueToListItem(
  locale: string,
  value?: Location | Location[] | null
): ListItem<Location> | Array<ListItem<Location>> | null {
  if (!value) {
    return null;
  }

  if (Array.isArray(value)) {
    return value
      .filter(
        (value, index, self) =>
          index === self.findIndex((t) => t?.placeId === value?.placeId)
      )
      .map(
        (v) =>
          ({
            label: v?.displayName,
            value: v
          } as ListItem<Location>)
      );
  }
  return {
    label: value?.displayName,
    value: value
  } as ListItem<Location>;
}

export function convertListItemToValue(
  listItem?: OptionTypeBase | Array<OptionTypeBase> | null
): Location | Location[] | null {
  if (!listItem) {
    return null;
  }

  if (Array.isArray(listItem)) {
    return listItem.map(
      (l) =>
        ({
          displayName: l.label,
          placeId: l?.value?.placeId || l?.value?.place_id
        } as Location)
    );
  }

  if (!listItem?.value?.place_id) {
    return null;
  }

  return {
    displayName: listItem.label,
    placeId: listItem?.value?.place_id
  } as Location;
}
